// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"0fbf7918","629":"d97a48d7","757":"7ecb1088"}[chunkId] + ".chunk.js";
};